Vue.component('ack-application-workflow', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-application-workflow',
	mixins: [languageMixins],
	created() {
		let hasParam = this.dentalApplicationId != null;

		if (hasParam) {
			this.setPageIsLoading(true);
			this.showPage = false;
			this.fetchTranslations({
				shopCdnUrl: this.shopCdnUrl,
				elementId: 'aw-' + this.dentalApplicationId.toLowerCase(),
				locale: this.userLanguage,
			}).then(() => {
				this.showPage = true;
				this.setPageIsLoading(false);
			});

			switch (this.dentalApplicationId.toLowerCase()) {
				case 'crown':
					this.applicationInfo = this.crownAppInfo;
					break;
				case 'splint':
					this.applicationInfo = this.splintAppInfo;
					break;
				case 'model':
					this.applicationInfo = this.modelAppInfo;
					break;
				case 'all-on-x':
					this.applicationInfo = this.allOnXAppInfo;
					break;
				default:
					this.applicationInfo = this.crownAppInfo;
					break;
			}
		} else {
			this.applicationInfo = this.crownAppInfo;
		}
	},
	mounted() {},
	props: {
		dentalApplicationId: {
			type: String,
			default: 'crown',
		},
	},
	computed: {
		...Vuex.mapGetters('localization', ['userLanguage']),

		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'application-workflow-page',
			crownAppInfo: {
				title_section: {
					title: 'application_workflow.application.crown.title_section.title',
					description: 'application_workflow.application.crown.title_section.description',
					paragraph: 'application_workflow.application.crown.title_section.paragraph',
					image_desktop:
						window.ackShopifyFileUrl("Applications_V4_Top_banner_a5035be7-69ef-4c4a-927e-0a3484b31f91.png"),
					image_mobile: null,
					learn_more: 'application_workflow.application.crown.title_section.learn_more',
					ctaGet3dps: 'application_workflow.application.crown.title_section.ctaGet3dps',
				},
				icons_section: {
					collateral_items: [
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_1.png"),
							title: 'application_workflow.application.crown.collateral_icons_section.item_one',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_2.png"),
							title: 'application_workflow.application.crown.collateral_icons_section.item_two',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_3.png"),
							title: 'application_workflow.application.crown.collateral_icons_section.item_three',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_4.png"),
							title: 'application_workflow.application.crown.collateral_icons_section.item_four',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_5.png"),
							title: 'application_workflow.application.crown.collateral_icons_section.item_five',
						},
					],
				},
				feature_section: {
					title: 'application_workflow.application.crown.feature_section.title',
					default_img:
						window.ackShopifyFileUrl("Applications_V4_Scan_c6c772d3-e1c4-4de0-b71b-a9d39f988e62.png"),
					feature_items: [
						{
							title:
								'application_workflow.application.crown.feature_section.feature_items.scan.title',
							description:
								'application_workflow.application.crown.feature_section.feature_items.scan.description',
							link: '/blogs/news/read-before-buying-an-intraoral-scanner-for-dental-3d-printing',
							image:
								window.ackShopifyFileUrl("Applications_V4_Scan_c6c772d3-e1c4-4de0-b71b-a9d39f988e62.png"),
							open: true,
						},
						{
							title:
								'application_workflow.application.crown.feature_section.feature_items.cad_design.title',
							description:
								'application_workflow.application.crown.feature_section.feature_items.cad_design.description',
							link: '/blogs/news/best-dental-cad-3d-printing-software-to-kick-off-2023',
							image:
								window.ackShopifyFileUrl("Applications_V4_CAD_Design_610e73d9-5a06-45b9-991b-eb789a28aecb.png"),
							open: false,
						},
						{
							title:
								'application_workflow.application.crown.feature_section.feature_items.cam_design.title',
							description:
								'application_workflow.application.crown.feature_section.feature_items.cam_design.description',
							link: '/blogs/news/alpha-ai-dental-3d-printing-slicing-software-what-s-new',
							image:
								window.ackShopifyFileUrl("Applications_V4_CAM_Design_cf0c782b-4209-4b9e-8e5c-9bb027af5864.png"),
							open: false,
						},
						{
							title:
								'application_workflow.application.crown.feature_section.feature_items.printing.title',
							description:
								'application_workflow.application.crown.feature_section.feature_items.printing.description',
							link: '/blogs/news/transforming-a-lab-with-the-ackuretta-sol-dental-3d-printer',
							image:
								window.ackShopifyFileUrl("Applications_V4_Printing_9f8ba005-c530-409e-88b7-ddccb9f95d44.png"),
							open: false,
						},
						{
							title:
								'application_workflow.application.crown.feature_section.feature_items.washing.title',
							description:
								'application_workflow.application.crown.feature_section.feature_items.washing.description',
							link: '/blogs/news/9-reasons-to-switch-to-the-cleani-washer',
							image:
								window.ackShopifyFileUrl("Applications_V4_Washing_5d0632a7-f29d-4ae9-9afe-f1a62e342e0b.png"),
							open: false,
						},
						{
							title:
								'application_workflow.application.crown.feature_section.feature_items.post_curing.title',
							description:
								'application_workflow.application.crown.feature_section.feature_items.post_curing.description',
							link: '/blogs/news/why-do-you-need-to-uv-cure-your-3d-printed-dental-application',
							image:
								window.ackShopifyFileUrl("Applications_V4_Post-Curing_5e726cd2-f366-4803-983d-ab8b892fe8b9.png"),
							open: false,
						},
						{
							title:
								'application_workflow.application.crown.feature_section.feature_items.polishing.title',
							description:
								'application_workflow.application.crown.feature_section.feature_items.polishing.description',
							link: null,
							image:
								window.ackShopifyFileUrl("Applications_V4_Polishing_and_Glazing_cb856a3c-f157-47ea-8e37-a3ddce185bb3.png"),
							open: false,
						},
					],
				},
				video_section: {
					title: 'application_workflow.application.crown.video_section.title',
					subtitle: 'application_workflow.application.crown.video_section.subtitle',
					description: 'application_workflow.application.crown.video_section.description',
					video: 'https://www.youtube.com/embed/DdAtAeuu4GQ?si=f6xQnRvrFwQQr1sV',
				},
				brands_section: {
					title: 'application_workflow.application.crown.brands_section.title',
					brands_list: [
						'argen',
						'arma_dental',
						'bego',
						'curo',
						'dentca',
						'dentona',
						'd_tech',
						'dreve',
						'dmg',
						'hpdent',
						'ictus_ental',
						'keystone',
						'nextdent',
						'pac_dent',
						'mack4d',
						'nyte3d',
						'shera',
						'voco',
						'saremco',
						'whipmix',
					],
				},
				image_section: {
					title: 'application_workflow.application.crown.element_bar_section.title',
					subtitle: 'application_workflow.application.crown.element_bar_section.subtitle',
					image: '',
					roiCalculator: {
						elfsightClassType: 'crownRoiCalculator',
					},
				},
				testimonials_section: {
					testimonial_items: [
						{
							id: 1,
							name: 'application_workflow.application.crown.testimonials_section.testimonial_items.testimonial_one.name',
							title:
								'application_workflow.application.crown.testimonials_section.testimonial_items.testimonial_one.title',
							quote:
								'application_workflow.application.crown.testimonials_section.testimonial_items.testimonial_one.description',
							img_src:
								window.ackShopifyFileUrl("KOL_Testimonials_Pokpong_Amornvit.jpg"),
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'application_workflow.application.crown.testimonials_section.testimonial_items.testimonial_two.name',
							title:
								'application_workflow.application.crown.testimonials_section.testimonial_items.testimonial_two.title',
							quote:
								'application_workflow.application.crown.testimonials_section.testimonial_items.testimonial_two.description',
							img_src:
								window.ackShopifyFileUrl("KOL_Testimonials_Steve_Tiang.jpg"),
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'application_workflow.application.crown.testimonials_section.testimonial_items.testimonial_three.name',
							title:
								'application_workflow.application.crown.testimonials_section.testimonial_items.testimonial_three.title',
							quote:
								'application_workflow.application.crown.testimonials_section.testimonial_items.testimonial_three.description',
							img_src:
								window.ackShopifyFileUrl("KOL_Testimonials_-Juliana_Andre.jpg"),
							altText: 'Third slide',
						},
					],
				},
			},
			splintAppInfo: {
				title_section: {
					title: 'application_workflow.application.splint.title_section.title',
					description: 'application_workflow.application.splint.title_section.description',
					paragraph: 'application_workflow.application.splint.title_section.paragraph',
					image_desktop:
						window.ackShopifyFileUrl("Applications_V4_Splint_Top_Banner.jpg"),
					image_mobile: null,
					learn_more: 'application_workflow.application.splint.title_section.learn_more',
					ctaGet3dps: 'application_workflow.application.splint.title_section.ctaGet3dps',
				},
				icons_section: {
					collateral_items: [
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_1.png"),
							title: 'application_workflow.application.splint.collateral_icons_section.item_one',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_2.png"),
							title: 'application_workflow.application.splint.collateral_icons_section.item_two',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_3.png"),
							title: 'application_workflow.application.splint.collateral_icons_section.item_three',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_4.png"),
							title: 'application_workflow.application.splint.collateral_icons_section.item_four',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_5.png"),
							title: 'application_workflow.application.splint.collateral_icons_section.item_five',
						},
					],
				},
				feature_section: {
					title: 'application_workflow.application.splint.feature_section.title',
					default_img:
						window.ackShopifyFileUrl("Applications_V4_Scan_c6c772d3-e1c4-4de0-b71b-a9d39f988e62.png"),
					feature_items: [
						{
							title:
								'application_workflow.application.splint.feature_section.feature_items.scan.title',
							description:
								'application_workflow.application.splint.feature_section.feature_items.scan.description',
							link: '/blogs/news/read-before-buying-an-intraoral-scanner-for-dental-3d-printing',
							image:
								window.ackShopifyFileUrl("Applications_V4_Scan_c6c772d3-e1c4-4de0-b71b-a9d39f988e62.png"),
							open: true,
						},
						{
							title:
								'application_workflow.application.splint.feature_section.feature_items.cad_design.title',
							description:
								'application_workflow.application.splint.feature_section.feature_items.cad_design.description',
							link: '/blogs/news/best-dental-cad-3d-printing-software-to-kick-off-2023',
							image:
								window.ackShopifyFileUrl("Applications_V4_Splint_CAD_Design.jpg"),
							open: false,
						},
						{
							title:
								'application_workflow.application.splint.feature_section.feature_items.cam_design.title',
							description:
								'application_workflow.application.splint.feature_section.feature_items.cam_design.description',
							link: '/blogs/news/alpha-ai-dental-3d-printing-slicing-software-what-s-new',
							image:
								window.ackShopifyFileUrl("Applications_V4_Splint_CAM_Design.jpg"),
							open: false,
						},
						{
							title:
								'application_workflow.application.splint.feature_section.feature_items.printing.title',
							description:
								'application_workflow.application.splint.feature_section.feature_items.printing.description',
							link: '/blogs/news/curo-pro-splint-soft-dental-3d-printing-resin',
							image:
								window.ackShopifyFileUrl("Applications_V4_Splint_Printing.jpg"),
							open: false,
						},
						{
							title:
								'application_workflow.application.splint.feature_section.feature_items.washing.title',
							description:
								'application_workflow.application.splint.feature_section.feature_items.washing.description',
							link: '/blogs/news/9-reasons-to-switch-to-the-cleani-washer',
							image:
								window.ackShopifyFileUrl("Applications_V4_Splint_Washing.jpg"),
							open: false,
						},
						{
							title:
								'application_workflow.application.splint.feature_section.feature_items.post_curing.title',
							description:
								'application_workflow.application.splint.feature_section.feature_items.post_curing.description',
							link: '/blogs/news/why-do-you-need-to-uv-cure-your-3d-printed-dental-application',
							image:
								window.ackShopifyFileUrl("Applications_V4_Splint_UV_Curing.jpg"),
							open: false,
						},
						{
							title:
								'application_workflow.application.splint.feature_section.feature_items.polishing.title',
							description:
								'application_workflow.application.splint.feature_section.feature_items.polishing.description',
							link: null,
							image:
								window.ackShopifyFileUrl("Applications_V4_Splint_Support_removal_and_polishing.jpg"),
							open: false,
						},
						{
							title:
								'application_workflow.application.splint.feature_section.feature_items.hard_splint.title',
							description:
								'application_workflow.application.splint.feature_section.feature_items.hard_splint.description',
							link: null,
							image:
								window.ackShopifyFileUrl("Workflow_Splint_First_image_expanded.jpg"),
							open: false,
						},
					],
				},
				hover_slider_image_section: {
					title: 'application_workflow.application.splint.hover_slide_section.title',
					description: 'application_workflow.application.splint.hover_slide_section.description',
					image_items: [
						{
							link: '/pages/curo-resins-for-dental-3d-printed-applications',
							src: window.ackShopifyFileUrl("Workflow_Splint_Second_Image_CURO.jpg"),
							alt: 'Soft Splints',
							title: 'Soft Splints',
						},
						{
							link: '/pages/flow-resins-for-dental-3d-printed-applications',
							src: window.ackShopifyFileUrl("Workflow_Splint_Second_Image_FLOW.jpg"),
							alt: 'Hard Splints',
							title: 'Hard Splints',
						},
					],
				},
				video_section: {
					title: 'application_workflow.application.splint.video_section.title',
					subtitle: 'application_workflow.application.splint.video_section.subtitle',
					description: 'application_workflow.application.splint.video_section.description',
					video: 'https://www.youtube.com/embed/dekXMZHUxMI?si=kxW3cWXg_pDRf8Xj',
				},
				brands_section: {
					title: 'application_workflow.application.splint.brands_section.title',
					brands_list: [
						'argen',
						'arma_dental',
						'bego',
						'curo',
						'dentca',
						'dentona',
						'd_tech',
						'dreve',
						'dmg',
						'hpdent',
						'ictus_ental',
						'keystone',
						'nextdent',
						'pac_dent',
						'mack4d',
						'nyte3d',
						'shera',
						'voco',
						'saremco',
						'whipmix',
					],
				},
				image_section: {
					title: 'application_workflow.application.splint.element_bar_section.title',
					subtitle: 'application_workflow.application.splint.element_bar_section.subtitle',
					image: '',
					roiCalculator: {
						elfsightClassType: 'splintRoiCalculator',
					},
				},
				testimonials_section: {
					testimonial_items: [
						{
							id: 1,
							name: 'application_workflow.application.splint.testimonials_section.testimonial_items.testimonial_one.name',
							title:
								'application_workflow.application.splint.testimonials_section.testimonial_items.testimonial_one.title',
							quote:
								'application_workflow.application.splint.testimonials_section.testimonial_items.testimonial_one.description',
							img_src:
								window.ackShopifyFileUrl("KOL_Testimonials_Pokpong_Amornvit.jpg"),
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'application_workflow.application.splint.testimonials_section.testimonial_items.testimonial_two.name',
							title:
								'application_workflow.application.splint.testimonials_section.testimonial_items.testimonial_two.title',
							quote:
								'application_workflow.application.splint.testimonials_section.testimonial_items.testimonial_two.description',
							img_src:
								window.ackShopifyFileUrl("KOL_Testimonials_Fermin_Ocanas.jpg"),
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'application_workflow.application.splint.testimonials_section.testimonial_items.testimonial_three.name',
							title:
								'application_workflow.application.splint.testimonials_section.testimonial_items.testimonial_three.title',
							quote:
								'application_workflow.application.splint.testimonials_section.testimonial_items.testimonial_three.description',
							img_src:
								window.ackShopifyFileUrl("KOL_Testimonials_-Juliana_Andre.jpg"),
							altText: 'Third slide',
						},
					],
				},
			},
			modelAppInfo: {
				title_section: {
					title: 'application_workflow.application.model.title_section.title',
					description: 'application_workflow.application.model.title_section.description',
					paragraph: 'application_workflow.application.model.title_section.paragraph',
					image_desktop:
						window.ackShopifyFileUrl("Applications_V4_Model_Top_Banner_c310e021-0542-4ef0-bc7a-6ac2394fca6f.jpg"),
					image_mobile: null,
					learn_more: 'application_workflow.application.model.title_section.learn_more',
					ctaGet3dps: 'application_workflow.application.model.title_section.ctaGet3dps',
				},
				icons_section: {
					collateral_items: [
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_1.png"),
							title: 'application_workflow.application.model.collateral_icons_section.item_one',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_2.png"),
							title: 'application_workflow.application.model.collateral_icons_section.item_two',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_3.png"),
							title: 'application_workflow.application.model.collateral_icons_section.item_three',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_4.png"),
							title: 'application_workflow.application.model.collateral_icons_section.item_four',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_5.png"),
							title: 'application_workflow.application.model.collateral_icons_section.item_five',
						},
					],
				},
				feature_section: {
					title: 'application_workflow.application.model.feature_section.title',
					default_img:
						window.ackShopifyFileUrl("Applications_V4_Scan_c6c772d3-e1c4-4de0-b71b-a9d39f988e62.png"),
					feature_items: [
						{
							title:
								'application_workflow.application.model.feature_section.feature_items.scan.title',
							description:
								'application_workflow.application.model.feature_section.feature_items.scan.description',
							link: '/blogs/news/read-before-buying-an-intraoral-scanner-for-dental-3d-printing',
							image:
								window.ackShopifyFileUrl("Applications_V4_Scan_c6c772d3-e1c4-4de0-b71b-a9d39f988e62.png"),
							open: true,
						},
						{
							title:
								'application_workflow.application.model.feature_section.feature_items.cad_design.title',
							description:
								'application_workflow.application.model.feature_section.feature_items.cad_design.description',
							link: '/blogs/news/best-dental-cad-3d-printing-software-to-kick-off-2023',
							image:
								window.ackShopifyFileUrl("Applications_V4_Model_CAD_Design.jpg"),
							open: false,
						},
						{
							title:
								'application_workflow.application.model.feature_section.feature_items.cam_design.title',
							description:
								'application_workflow.application.model.feature_section.feature_items.cam_design.description',
							link: '/blogs/news/alpha-ai-dental-3d-printing-slicing-software-what-s-new',
							image:
								window.ackShopifyFileUrl("Applications_V4_Model_CAM_Design.jpg"),
							open: false,
						},
						{
							title:
								'application_workflow.application.model.feature_section.feature_items.printing.title',
							description:
								'application_workflow.application.model.feature_section.feature_items.printing.description',
							link: '/blogs/news/transforming-a-lab-with-the-ackuretta-sol-dental-3d-printer',
							image:
								window.ackShopifyFileUrl("Applications_V4_Model_Printing.jpg"),
							open: false,
						},
						{
							title:
								'application_workflow.application.model.feature_section.feature_items.washing.title',
							description:
								'application_workflow.application.model.feature_section.feature_items.washing.description',
							link: '/blogs/news/9-reasons-to-switch-to-the-cleani-washer',
							image:
								window.ackShopifyFileUrl("Applications_V4_Model_Washing.jpg"),
							open: false,
						},
						{
							title:
								'application_workflow.application.model.feature_section.feature_items.post_curing.title',
							description:
								'application_workflow.application.model.feature_section.feature_items.post_curing.description',
							link: '/blogs/news/why-do-you-need-to-uv-cure-your-3d-printed-dental-application',
							image:
								window.ackShopifyFileUrl("Applications_V4_Model_UV_Curing.jpg"),
							open: false,
						},
						{
							title:
								'application_workflow.application.model.feature_section.feature_items.polishing.title',
							description:
								'application_workflow.application.model.feature_section.feature_items.polishing.description',
							link: null,
							image:
								window.ackShopifyFileUrl("Applications_V4_Model_Thermoform.jpg"),
							open: false,
						},
					],
				},
				video_section: {
					title: 'application_workflow.application.model.video_section.title',
					subtitle: 'application_workflow.application.model.video_section.subtitle',
					description: 'application_workflow.application.model.video_section.description',
					video: 'https://www.youtube.com/embed/7q5kSidAwNE?si=2ybqEdcZEwTOfkTp',
				},
				brands_section: {
					title: 'application_workflow.application.model.brands_section.title',
					brands_list: [
						'argen',
						'arma_dental',
						'bego',
						'curo',
						'dentca',
						'dentona',
						'd_tech',
						'dreve',
						'dmg',
						'hpdent',
						'ictus_ental',
						'keystone',
						'nextdent',
						'pac_dent',
						'mack4d',
						'nyte3d',
						'shera',
						'voco',
						'saremco',
						'whipmix',
					],
				},
				testimonials_section: {
					testimonial_items: [
						{
							id: 1,
							name: 'application_workflow.application.model.testimonials_section.testimonial_items.testimonial_one.name',
							title:
								'application_workflow.application.model.testimonials_section.testimonial_items.testimonial_one.title',
							quote:
								'application_workflow.application.model.testimonials_section.testimonial_items.testimonial_one.description',
							img_src:
								window.ackShopifyFileUrl("KOL_Testimonials_Pokpong_Amornvit.jpg"),
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'application_workflow.application.model.testimonials_section.testimonial_items.testimonial_two.name',
							title:
								'application_workflow.application.model.testimonials_section.testimonial_items.testimonial_two.title',
							quote:
								'application_workflow.application.model.testimonials_section.testimonial_items.testimonial_two.description',
							img_src:
								window.ackShopifyFileUrl("KOL_Testimonials_Russell_Schafer.jpg"),
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'application_workflow.application.model.testimonials_section.testimonial_items.testimonial_three.name',
							title:
								'application_workflow.application.model.testimonials_section.testimonial_items.testimonial_three.title',
							quote:
								'application_workflow.application.model.testimonials_section.testimonial_items.testimonial_three.description',
							img_src:
								window.ackShopifyFileUrl("KOL_Testimonials_-Juliana_Andre.jpg"),
							altText: 'Third slide',
						},
					],
				},
			},
			allOnXAppInfo: {
				title_section: {
					title: '3D Printing All on X Restorations',
					description:
						'Print precise All-on-X provisional restorations with the Ackuretta 3D Printing Solution and streamline your full-arch implant workflows. Our validated system enables clinicians to deliver accurate, esthetic, and durable All-on-X provisionals using validated biocompatible resins designed specifically for high-performance temporary full-arch applications.',
					paragraph: null,
					image_desktop:
						window.ackShopifyFileUrl("Applications_All_on_X_Top_banner.png"),
					image_mobile: null,
					learn_more: 'application_workflow.application.crown.title_section.learn_more',
					ctaGet3dps: 'Get my 3D Printing Solution for All on X',
				},
				icons_section: {
					collateral_items: [
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_1.png"),
							title: 'Scan & Plan',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_2.png"),
							title: 'CAD/CAM Design',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_3.png"),
							title: 'Print',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_V4_icon_4.png"),
							title: 'Post-Process',
						},
						{
							image:
								window.ackShopifyFileUrl("Applications_All_on_X_icon_5.png"),
							title: 'Seat',
						},
					],
				},
				feature_section: {
					title: '3D Printing Workflow for All on X',
					default_img:
						window.ackShopifyFileUrl("Applications_V4_Scan_c6c772d3-e1c4-4de0-b71b-a9d39f988e62.png"),
					feature_items: [
						{
							title: 'Scan',
							description:
								"Start by taking a digital impression of a patient's oral structures using a specialized intraoral scanner or a desktop optical scanner. For All-on-X workflows, capture the entire arch with precision. This scan will serve as the foundation for both the surgical guide and the provisional restoration design, ensuring proper implant placement and prosthetic fit.",
							link: '/blogs/news/read-before-buying-an-intraoral-scanner-for-dental-3d-printing',
							image:
								window.ackShopifyFileUrl("Applications_All_on_X_Scan.png"),
							open: true,
						},
						{
							title: 'Planning',
							description:
								'Intraoral scans, clinical photographs, and CBCT data are precisely aligned to develop a comprehensive surgical and prosthetic treatment plan. Using this integrated digital workflow, a patient-specific surgical guide can be accurately 3D printed on the Ackuretta SOL SE dental 3D printer, utilizing our specialized CURO Guide resin.',
							link: '/blogs/dental-3d-printing-articles/dental-3d-printing-precision?_pos=3&_sid=b0804883c&_ss=r',
							image:
								window.ackShopifyFileUrl("Applications_All_on_X_Planning.jpg"),
							open: false,
						},
						{
							title: 'CAD Design',
							description:
								'Following the scan and planning steps, utilize Computer-Aided Design (CAD) software to develop the All-on-X restoration. Design the full-arch prosthesis with precision, focusing on emergence profiles, occlusal relationships, and aesthetic considerations. Strategically plan the prosthesis to ensure perfect alignment with intended implant positions, creating a functional and cosmetically refined restoration.',
							link: '/blogs/news/best-dental-cad-3d-printing-software-to-kick-off-2023',
							image:
								window.ackShopifyFileUrl("Applications_All_on_X_CAD_Design.png"),
							open: false,
						},
						{
							title: 'CAM Design',
							description:
								'Use a CAM (Computer-Aided Manufacturing) software such as our ALPHA AI slicing software to prepare the design files for 3D printing. For All-on-X provisionals, orientation is crucial to avoid support placement in critical areas. ALPHA AI Premium offers AI-automated supports and orientation optimized for the restoration, ensuring precise print quality and minimal aesthetic disruption.',
							link: '/blogs/news/alpha-ai-dental-3d-printing-slicing-software-what-s-new',
							image:
								window.ackShopifyFileUrl("Applications_All_on_X_CAM_Design.png"),
							open: false,
						},
						{
							title: 'Printing',
							description:
								'Prepare the printer using FLOW C&B resin, renowned for its exceptional mechanical properties and esthetics for temporary All-on-X provisionals. Shake the resin bottle for 2 minutes before carefully pouring into the vat. The SOL Medium Build Platform provides an optimal printing area and speed, ensuring precise and high-quality components for the complete digital workflow.',
							link: '/blogs/news/transforming-a-lab-with-the-ackuretta-sol-dental-3d-printer',
							image:
								window.ackShopifyFileUrl("Applications_All_on_X_Printing.png"),
							open: false,
						},
						{
							title: 'Washing',
							description:
								"Clean the All-on-X provisional made with FLOW C&B resin by either hand washing with isopropyl alcohol spray and wipes, or using the CLEANI washer. Maintain a total wash time under 10 minutes to preserve the restoration's integrity. Dry the component completely with compressed air before proceeding to curing, ensuring optimal surface preparation for the next stage of the workflow.",
							link: '/blogs/news/9-reasons-to-switch-to-the-cleani-washer',
							image:
								window.ackShopifyFileUrl("Applications_All_on_X_Washing.png"),
							open: false,
						},
						{
							title: 'Post-Curing',
							description:
								'Post-cure the All-on-X provisional using the FLOW C&B profile in CURIE Plus, optionally with nitrogen to enhance mechanical properties up to 25%. Utilize the validated curing parameters to ensure optimal strength and aesthetic quality of the restoration.',
							link: '/blogs/news/why-do-you-need-to-uv-cure-your-3d-printed-dental-application',
							image:
								window.ackShopifyFileUrl("Applications_All_on_X_Post-Curing.png"),
							open: false,
						},
						{
							title: 'Finishing',
							description:
								'After post-curing, remove supports from the All-on-X provisional using clippers. Smooth any residual stubs with a carbide bur, then polish with pumice for a high-shine finish. For enhanced esthetics, apply characterization stains to create natural-looking features. ',
							link: '/blogs/news/why-do-you-need-to-uv-cure-your-3d-printed-dental-application',
							image:
								window.ackShopifyFileUrl("Applications_All_on_X_Finishing.png"),
							open: false,
						},
						{
							title: 'Seating',
							description:
								"Seat the All-on-X provisional on the implants, carefully checking for passive fit and proper occlusion. Meticulously evaluate the restoration's alignment and make any necessary adjustments to ensure optimal patient comfort and functional performance. After confirming satisfactory fit and integration, the treatment can progress to the final restoration phase following the appropriate healing period.",
							link: null,
							image:
								window.ackShopifyFileUrl("Applications_All_on_X_Seating.png"),
							open: false,
						},
					],
				},
				video_section: {
					title:
						'3D Printing in Restorative Dentistry by Dr. Christian Brenes ft. BEGO VerseoSmile Crown Plus',
					subtitle: 'Practice Insights',
					description:
						"Discover how to transform your digital restorative workflows with expert insights on All-on-X provisionals and crown applications. Dr. Brenes shares clinical cases and validated protocols while BEGO demonstrates how high-performance materials integrate with Ackuretta's ecosystem for predictable, efficient outcomes in modern implant and restorative dentistry.RetryClaude can make mistakes. Please double-check responses.",
					video: 'https://www.youtube.com/embed/a-dwRiamBkM',
				},
				brands_section: {
					title: 'Validated All-on-X Provisional Materials',
					brands_list: [
						'argen',
						'arma_dental',
						'bego',
						'curo',
						'dentca',
						'dentona',
						'd_tech',
						'dreve',
						'dmg',
						'hpdent',
						'ictus_ental',
						'keystone',
						'nextdent',
						'pac_dent',
						'mack4d',
						'nyte3d',
						'shera',
						'voco',
						'saremco',
						'whipmix',
					],
				},
				image_section: {
					title: 'A Digital Dental Solution Within Reach',
					subtitle: 'Cost-effective chairside All on X in your dental practice',
					image: '',
					roiCalculator: {
						elfsightClassType: 'allOnXRoiCalculator',
					},
				},
				testimonials_section: {
					testimonial_items: [
						{
							id: 1,
							name: 'Dr. Dr. Pokpong Amornvit',
							title: 'DDS,MS, PHD Oral Health Science',
							quote:
								"Ackuretta's ALPHA AI is intuitive and user-friendly. Moreover, SOL 3D printer and CURO resins have improved the quality of care I provide to my patients, and the ability to create custom restorations has expanded the range of services I can offer.",
							img_src:
								window.ackShopifyFileUrl("KOL_Testimonials_Pokpong_Amornvit.jpg"),
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'Dr. Juliana André',
							title: 'Lab Owner & Dental Technician',
							quote:
								'The quality of CURO resins is very high, the applications come out very clean after washing and curing. CURO fits great into our workflow and we are very satisfied with it.',
							img_src:
								window.ackShopifyFileUrl("KOL_Testimonials_-Juliana_Andre.jpg"),
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'Dr. Steve Tiang',
							title: 'General Dentist',
							quote:
								"A 3-unit bridge and a molar crown in 21 minutes? Crazy. But that’s what I got with the SOL's Small Build Platform and CURO Crown resin. Awesome sauce!",
							img_src:
								window.ackShopifyFileUrl("KOL_Testimonials_Steve_Tiang.jpg"),
							altText: 'Third slide',
						},
					],
				},
			},
		};
	},
	methods: {
		// ...Vuex.mapActions(['sayHi', 'someAction']),
		...Vuex.mapActions('localization', ['fetchTranslations']),
		toggleItem(selectedIndex) {
			// Close all items
			this.accordionItems.forEach((item, index) => {
				if (index === selectedIndex) {
					// Toggle the selected item
					this.accordionItems[index].open = !this.accordionItems[index].open;
				} else {
					// Ensure all other items are closed
					this.accordionItems[index].open = false;
				}
			});
		},
	},
	beforeDestroy() {},
	watch: {
		slides: {
			handler() {},
			deep: false,
		},
	},
});
